import { Controller } from "@hotwired/stimulus"

// 사용 시간 입력값에 따라 단시간/임시 작업 여부를 자동 판정하여
// 표시용 checkbox 두 개를 갱신한다.
//
// 판정 로직 (서버측 ProductUsageInfo#short_time_work? / #temp_work? 와 동일):
//   short_time_work? = 사용주기 ≠ daily (즉 weekly/monthly/yearly)
//                      AND 일사용시간 ∈ [under_15m_day, under_1h_day]
//   temp_work?       = (월사용시간 == under_10h_month AND 사용주기 ∈ [monthly, yearly])
//                      OR (월사용시간 == under_24h_month AND 사용주기 == yearly)
//     — 월 10시간 미만은 '월 1회 이상 ~ 연 1회 이상' 만 임시작업 (매일·주 1회는 '일시적' 작업 아님).
//
// 표시용 checkbox 는 disabled 라 폼 제출 시 전송되지 않는다 (DB 영향 없음).
//
// 사용처마다 input name 접두사가 다를 수 있으므로 (`usage_info[...]`, `use_info[...]`),
// 입력 name 대신 wrapper 의 data-usage-classifier-field 속성으로 식별한다.
//   data-usage-classifier-field="frequency"  → 사용주기 라디오 그룹
//   data-usage-classifier-field="daily"      → 일 사용시간 라디오 그룹
//   data-usage-classifier-field="monthly"    → 월 사용시간 라디오 그룹
export default class extends Controller {
  static targets = ["shortTime", "temp"]

  static SHORT_TIME_FREQ = ["weekly", "monthly", "yearly"]
  static SHORT_TIME_DAILY = ["under_15m_day", "under_1h_day"]
  // 월 10시간 미만 작업이 임시작업으로 인정되는 사용주기 (월 1회 이상 ~ 연 1회 이상)
  static TEMP_FREQ_UNDER_10H = ["monthly", "yearly"]

  connect() {
    this.update()
  }

  update() {
    const freq    = this.#fieldValue("frequency")
    const daily   = this.#fieldValue("daily")
    const monthly = this.#fieldValue("monthly")

    const klass = this.constructor

    if (this.hasShortTimeTarget) {
      this.shortTimeTarget.checked =
        klass.SHORT_TIME_FREQ.includes(freq) && klass.SHORT_TIME_DAILY.includes(daily)
    }

    if (this.hasTempTarget) {
      this.tempTarget.checked =
        (monthly === "under_10h_month" && klass.TEMP_FREQ_UNDER_10H.includes(freq)) ||
        (monthly === "under_24h_month" && freq === "yearly")
    }
  }

  #fieldValue(field) {
    const wrapper = this.element.querySelector(`[data-usage-classifier-field="${field}"]`)
    if (!wrapper) return null
    const checked = wrapper.querySelector("input[type=radio]:checked")
    return checked ? checked.value : null
  }
}
